module.exports = __webpack_public_path__ + "static/img/sola-academy.608008a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sola-academy.jpg
// module id = /30s
// module chunks = 0